export default __webpack_public_path__ + "static/media/winning.85cfe4e2.png";